import { useState } from "react";
import { Box, IconButton, Slider, Tooltip } from "@mui/material";
import { VolumeDown, VolumeUp } from "@mui/icons-material";

export const EditorDAWVolumeSlider = ({ onChange, value }) => {
  const [volValue, setValue] = useState(value);

  const handleChange = (v) => {
    if (v && v.target) {
      const newValue = v.target.value;
      onChange(newValue);
      setValue(newValue);
    }
  };

  const increaseVolume = () => {
    let newValue = volValue + 10 <= 100 ? volValue + 10 : 100;
    onChange(newValue);
    setValue(newValue);
  };

  const decreaseVolume = () => {
    let newValue = volValue - 10 >= 0 ? volValue - 10 : 0;
    onChange(newValue);
    setValue(newValue);
  };

  return (
    <Box display="flex" alignItems="center" flex={1} gap={1} width={1}>
      <Tooltip title="Decrease Volume">
        <IconButton onClick={decreaseVolume}>
          <VolumeDown color="primary" fontSize="small" />
        </IconButton>
      </Tooltip>
      <Slider
        aria-label="Volume"
        defaultValue={0}
        max={100}
        min={0}
        size="small"
        step={1}
        value={volValue}
        onChange={handleChange}
      />
      <Tooltip title="Increase Volume">
        <IconButton onClick={increaseVolume}>
          <VolumeUp color="primary" fontSize="medium" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
